import React, { useCallback } from 'react';
import QuoteContext, { useQuoteContext } from '@/dataroom/app/landing/QuoteContext';
import FinalForm, { Field } from '@framework/ui/Organisms/FinalForm';
import ReCaptcha from '@framework/ui/Molecules/Form/ReCaptcha';
import PhoneInput from '@dealroadshow/uikit-input/PhoneInput';
import Clearfix from '@dealroadshow/uikit-clearfix';
import Spinner from '@dealroadshow/uikit-loader/Spinner';
import Textarea from '@dealroadshow/uikit-textarea';
import Input from '@dealroadshow/uikit-input';
import { CheckboxInput } from '@dealroadshow/uikit-checkbox';
import { Select } from '@framework/ui/Organisms/FinalForm/Fields/Select';
import QuoteFormSuccess from './QuoteFormSuccess';
import spacesStyles from '@dealroadshow/uikit-styles/helpers/spaces.module.scss';
import Button, { ButtonVariantType } from '@dealroadshow/uikit-button';
import styles from './quoteForm.module.scss';
import validate from './validator';
import { dataroomProviderCollection } from './constants';
import { TFinalFormRenderProp } from '@framework/ui/Organisms/FinalForm/interfaces';
import { I17g5FormData } from '@/dataroom/app/landing/useGetQuote';

const QuoteForm = () => {
  const {
    isFetching,
    isSuccessScreen,
    getQuote,
  } = useQuoteContext();

  const renderForm = useCallback<TFinalFormRenderProp<I17g5FormData>>(() => (
    <>
      <div className={ styles.activeDataroomsWrp }>
        <Field
          name="activeDatarooms"
          label="# of Active Data Rooms"
          placeholder="#"
          component={ Input }
          dataTest="quoteActiveDataroomsInput"
        />
      </div>
      <div className={ styles.currentDataroomProviderWrp }>
        <Field
          name="currentDataroomProvider"
          label="Current 17g5 Data Room Provider"
          component={ Select }
          options={ dataroomProviderCollection }
          isSimpleValue
          dataTest="currentDataroomProviderReduxFormSelect"
        />
      </div>
      <Clearfix />
      <Field
        name="company"
        label="Company"
        placeholder="Company Name"
        component={ Input }
        dataTest="quoteCompanyNameInput"
      />
      <div className={ styles.firstNameWrp }>
        <Field
          name="firstName"
          label="First name"
          placeholder="First Name"
          component={ Input }
          dataTest="quoteFirstNameInput"
        />
      </div>
      <div className={ styles.lastNameWrp }>
        <Field
          name="lastName"
          label="Last name"
          placeholder="Last Name"
          component={ Input }
          dataTest="quoteLastNameInput"
        />
      </div>
      <Clearfix />
      <Field
        name="email"
        label="Corporate email"
        placeholder="Email Address"
        component={ Input }
        dataTest="quoteCorporateEmailInput"
      />
      <Field
        name="phone"
        label="Phone Number"
        placeholder="Phone"
        isFinalForm
        component={ PhoneInput }
        dataTest="quotePhoneNumberInput"
      />
      <Field
        name="notes"
        label="Additional notes (OPTIONAL)"
        placeholder="Your notes..."
        component={ Textarea }
        rows={ 6 }
        dataTest="notesQuoteFormTextArea"
      />
      <Field
        name="callback"
        label="Request a call back from a 17g5.com specialist?"
        type="checkbox"
        className={ styles.checkbox }
        component={ CheckboxInput }
        isErrorMessage={ false }
        dataTest="requestCallCheckbox"
      />
      <div className={ styles.recaptchaWrp }>
        <Field
          name="recaptcha"
          component={ ReCaptcha }
        />
      </div>
      <div className={ styles.buttonWrp }>
        <Button
          variant={ ButtonVariantType.action }
          className={ spacesStyles.mrn }
          type="submit"
          title="Request Quote"
          dataTest="quoteFormSubmitButton"
        />
      </div>
    </>
  ), []);

  if (isSuccessScreen) {
    return <QuoteFormSuccess />;
  }

  return (
    <div className={ styles.formWrp }>
      <div className={ styles.form }>
        <Spinner
          isVisible={ isFetching }
          overlay
        />
        <FinalForm<I17g5FormData>
          dataTest="getQuoteForm"
          onSubmit={ getQuote }
          render={ renderForm }
          validate={ validate }
        />
      </div>
    </div>
  );
};

export default () => (
  <QuoteContext>
    <QuoteForm />
  </QuoteContext>
);
